import "./App.scss";
import "./inlineStyles.scss";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Landing from "./pages/Landing/Landing";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import { store } from "./app/store";
import { Provider } from "react-redux";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import QuotesPage from "./pages/QuotesPage/QuotesPage";
import Proposal from "./pages/Proposal/Proposal";
import ThankYou from "./pages/ThankYou/ThankYou";
import ProposalSummary from "./pages/ProposalSummary/ProposalSummary";

import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import ShareButton from "./components/ShareButton/ShareButton";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";

import OtpModal from "./components/Modal/OtpModal.tsx";
import useUrlQuery from "./hooks/useUrlQuery";
import { useEffect, useState } from "react";

import { persistQueryClient } from "@tanstack/react-query-persist-client";
import { createAsyncStoragePersister } from "@tanstack/query-async-storage-persister";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: 1000 * 60 * 60 * 24, // 24 hours
    },
  },
});

const localStoragePersister = createAsyncStoragePersister({
  storage: window.localStorage,
});

persistQueryClient({
  queryClient,
  persister: localStoragePersister,
});

const AppContent = () => {
  const [open, setOpen] = useState(false);
  const [sessionToken, setSessionToken] = useState("");

  const { get } = useUrlQuery();

  useEffect(() => {
    const token = get("session_token");
    const sessionTokenStored = sessionStorage.getItem("session_token");

    if (token && !sessionTokenStored) {
      setSessionToken(token);
      setOpen(true);
    }
  }, []);

  return (
    <>
      <ScrollToTop>
        <Navbar />
        <ShareButton />

        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/quotes" element={<QuotesPage />} />
          <Route path="/proposal" element={<Proposal />} />
          <Route path="/summary" element={<ProposalSummary />} />
          <Route path="/thankyou" element={<ThankYou />} />
        </Routes>

        <Footer />
      </ScrollToTop>

      <OtpModal
        open={open}
        sessionToken={sessionToken}
        onSuccess={() => setOpen(false)}
        onClose={() => setOpen(false)}
      />
    </>
  );
};

function App() {
  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <Router>
          <AppContent />
        </Router>

        <ToastContainer
          position="bottom-right"
          autoClose={3000}
          limit={3}
          pauseOnHover
          theme="colored"
        />

        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </Provider>
  );
}

export default App;
